import React from "react";
import { InteractiveTooltip } from "@my-scoot/component-library-legacy";
import { InfoOutlined } from "@material-ui/icons";
import { Button } from "@my-scoot/component-library-legacy";
import style from "./Tooltip.module.css";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import { TootltipData } from "./constants/Tooltips.constants";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";

const Tooltip = ({ id, open, setOpenTooltipId, displayTitle = "" }) => {
  const isDesktop = useDesktopMediaQuery();
  const handleTooltipToggle = (id) => {
    setOpenTooltipId(open ? null : id);
  };
  const isSeeReferenceModalOpen = useAdminPanelStore(
    (state) => state.isSeeReferenceModalOpen
  );
  return (
    <InteractiveTooltip
      open={open && !isSeeReferenceModalOpen}
      totalSteps={0}
      title={
        <div className={style.toolTipContainer}>
          {TootltipData[id]?.text || displayTitle}
        </div>
      }
      primaryBtnText="Got it"
      customFooter={
        <div className={style.buttonWrapper}>
          <Button
            onClick={() => handleTooltipToggle(id)}
            className={style.primarybtn}
          >
            Got it
          </Button>
        </div>
      }
      tooltipClasses={{
        popper: style.interactiveToolTipPopper,
        tooltipPlacementRight: style.tooltipPlacementBottom,
        tooltipPlacementBottom: style.tooltipPlacementBottom,
      }}
      arrowClassName={style.arrowClassName}
      placement={isDesktop ? "right" : "bottom"}
    >
      <InfoOutlined
        className={style.infoIcon}
        onClick={() => handleTooltipToggle(id)}
      />
    </InteractiveTooltip>
  );
};
export default Tooltip;
